<template>
  <div>
    <div class="row">
      <h1>支店選択画面</h1>
    </div>
    <div class="row">
      <h2>支店を選択してください。</h2>
    </div>
    <div class="row">
      <p>支店名の頭文字をクリックしてください。</p>
      <p>例：青山支店→「あ」をクリック</p>
    </div>
    <div class="row">
      <p>※ 英字で始まる場合は「ABC」を、番号で始まる場合は「数字」を押してください。</p>
    </div>
    <div class="row">
        <character-selector-button
          @clickCharacterSelectorButton="getBankList"
        />
    </div>

    <div v-if="bankBranchList != null" class="row" style="justify-content: center; margin-top: 1rem;">
      <img v-bind:src="arrowImagePath">
    </div>

    <div v-if="bankBranchList != null" class="row" style="margin-top: 1rem">
      <div class="result">
        検索結果: 『{{clickedCharacter}}』は{{ this.bankBranchList.length }}件です。
      </div>
    </div>
    <div v-if="bankBranchList != null" class="row">
      <div v-if="bankBranchList.length != '0'" class="select-part">
        <select v-model="selectedBankBranch" @change="goButtonDisabled = false">
          <option value='' disabled selected style='display:none;'>支店を選択してください。</option>
          <option v-for="bankBranchInfo in bankBranchList" :value="bankBranchInfo.name" :key="bankBranchInfo.id">
            {{ bankBranchInfo.name }}
          </option>
        </select>
      </div>
    </div>

    <div class="row">
      <div class="btn-part">
        <button-part
          :button-disabled="goButtonDisabled"
          back-label="金融機関選択画面へ"
          go-label="決定"
          @back="$emit('backSelectBankModal'), bankBranchList = null"
          @go="setSelectedBankBranchInfo"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ButtonPart from '../parts/button_part.vue'
import CharacterSelectorButton from '../parts/character_selector_button.vue'
export default {
  components: {
    ButtonPart,
    CharacterSelectorButton
  },
  data () {
    return {
      selectedBankBranchText: '',
      bankBranchList: null,
      goButtonDisabled: true,
      clickedCharacter: null,
      errorCounter: 0
    }
  },
  props: {
    apiKey: {
      type: String,
      required: true
    },
    bankCode: {
      type: String
    }
  },
  methods: {
    getBankList (selectedCharacter, pattern) {
      this.clickedCharacter = selectedCharacter[0]
      // 支店が選択されるまで画面遷移を防ぐためボタンを非活性に
      this.goButtonDisabled = true

      const queryParam = this.createQueryParam(selectedCharacter, pattern)

      const xhr = new XMLHttpRequest()
      xhr.onreadystatechange = () => {
        if (xhr.readyState !== 4) return
        if (xhr.status === 200) {
          const jsonObj = JSON.parse(xhr.responseText)
          this.bankBranchList = jsonObj.data
        } else if (xhr.status === 429 && this.errorCounter == 0) {
          window.alert('予期しないエラーが発生しました。\n少し時間を置いてから再度操作してください。')
          this.errorCounter++
        } else {
          this.loggerAlert (xhr.status, xhr.responseText)
        }
      }
      xhr.open("GET", this.searchBankBranchUrl + this.bankCode + this.searchBankBranchQueryParamWithHira + queryParam)
      xhr.setRequestHeader("apikey", this.apiKey)
      xhr.timeout = 10000; //10秒過ぎましたらタイムアウトになります。
      xhr.ontimeout = () => {
        this.loggerAlert ("timeout", "server connection timed out")
      }
      xhr.send()

    },
    createQueryParam (selectedCharacter, pattern) {
      if (selectedCharacter[0].match(/^[\u3040-\u309F]/)) {
        return `(${selectedCharacter.map(element => 'hiragana==' + element + '*').join(',')})`
      } else {
        return `name=re=^${pattern}`
      }
    },
    setSelectedBankBranchInfo () {
      const selectedBankBranchObj = this.bankBranchList.find(element => element.name === this.selectedBankBranch)
      const selectedBankBranchCode = selectedBankBranchObj.code
      this.$emit('decision', {bankBranchName: this.selectedBankBranch, bankBranchCode: selectedBankBranchCode})
    },
    loggerAlert (statusCode, messageText) {
      const outputLogRequest = new XMLHttpRequest()
      const requestBodyHash = {level: 'warn', message: {status: `${statusCode}`, message: `[cannot_get_bank_branch_list] ${messageText}`}}
      outputLogRequest.open('POST', '/api/v1/logging', true)
      outputLogRequest.setRequestHeader('Content-Type', 'application/json')
      outputLogRequest.send(JSON.stringify(requestBodyHash))

      window.alert(`予期しないエラーが発生しました。\n一時的に金融機関検索が利用できないため、\nお手数ですが金融機関情報の入力をお願いいたします。\nエラーコード: ${statusCode}`)
      if (document.getElementById('_storage_bank_account_bankapi_status')){
        this.$emit('apiCheck', false)
      }
    }
  },
  computed: {
    searchBankBranchUrl () {
      return 'https://apis.bankcode-jp.com/v1/banks/'
    },
    searchBankBranchQueryParamWithHira () {
      return '/branches?limit=2000&filter='
    },
    selectedBankBranch: {
      get () {
        return this.selectedBankBranchText
      },
      set (value) {
        this.selectedBankBranchText = value
        this.buttonDisabledStatus = false
      }
    },
    arrowImagePath () {
      return "/arrow.png"
    }
  }
}
</script>

<style lang="scss" scoped>
.row {
  margin-left: 0rem;
  margin-right: 0rem;
  .clickCharacterSelectorButtonselect-part {
    margin: auto;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .result {
    display: flex;
    margin: auto;
    text-align: center;
    color: #c72736;
    font-weight: 700;
  }
  .select-part {
    display: flex;
    width: 100%;
    justify-content: center;
  }
  .btn-part {
    display: flex;
    width: 100%;
    justify-content: center;
  }
}
select {
  width: 80%;
  padding: 1rem 0.5rem;
  text-align: center;
  margin-top: 1rem;
}

// TODO: 後ほど変数を利用するように修正
@media screen and (max-width: 575px) {
  select {
    width: 100%;
  }
}
</style>
